import axios from 'axios';
import { BASE_SETTINGS_URL } from '../components/constants';

export const createTask = async (taskData) => {
    try {
        const response = await axios.post(`${BASE_SETTINGS_URL}/task`, taskData);
        return response.data;
    } catch (error) {
        console.error('Create task error:', error.response?.data || error.message);
        throw error.response?.data || error.message;
    }
};

export const updateTask = async (taskData) => {
    try {
        console.log('Updating task:', taskData);  // Log the task data being sent
        const response = await axios.put(`${BASE_SETTINGS_URL}/task`, taskData);
        const updatedTask = await getTaskById(taskData.id);
        return updatedTask;
    } catch (error) {
        console.error('Update task error:', error.response?.data || error.message);
        throw error.response?.data || error.message;
    }
};

export const getAllTasks = async (userEmail = null) => {
    try {
        const params = userEmail ? { user_email: userEmail } : {};
        const response = await axios.get(`${BASE_SETTINGS_URL}/tasks`, { params });
        return response.data;
    } catch (error) {
        console.error('Get tasks error:', error.response?.data || error.message);
        throw error.response?.data || error.message;
    }
};

export const deleteTask = async (taskId) => {
    try {
        const response = await axios.delete(`${BASE_SETTINGS_URL}/task`, { 
            data: { 
                id: String(taskId)  // Ensure id is a string
            } 
        });
        return response.data;
    } catch (error) {
        console.error('Delete task error:', error.response?.data || error.message);
        throw error.response?.data || error.message;
    }
};

export const getTaskById = async (taskId) => {
    try {
        const response = await axios.get(`${BASE_SETTINGS_URL}/task/${taskId}`);
        return response.data;
    } catch (error) {
        console.error('Get task by ID error:', error.response?.data || error.message);
        throw error.response?.data || error.message;
    }
};
